module.exports = __webpack_public_path__ + "img/user-avatar-wrapper.1ea70ba2.svg";